import { configureStore } from '@reduxjs/toolkit';
import casaCerradaReducer from './CasaCerrada/casaCerrada';

const store = configureStore({
  reducer: {
    casaCerrada: casaCerradaReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
